import { render, staticRenderFns } from "./SharingStatusesScroller.vue?vue&type=template&id=54afd350&scoped=true&"
import script from "./SharingStatusesScroller.vue?vue&type=script&lang=js&"
export * from "./SharingStatusesScroller.vue?vue&type=script&lang=js&"
import style0 from "./SharingStatusesScroller.vue?vue&type=style&index=0&id=54afd350&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54afd350",
  null
  
)

export default component.exports